import { Box, TextField } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import EventIcon from "@mui/icons-material/Event";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getEndOfMonth, getFirstDateOfCurrentMonthPayloadFormate, getLastDateOfCurrentMonthPayloadFormat, swalAlertPopProps } from "../utils/commonUtils";
import Swal from "sweetalert2";

export const ToFromDateMonth = ({ startDateFormat, setstartDateFormat, endDate, setEndDate }) => {
  const datePickerRef = useRef();
  const [SelectedStartDate, setSelectedStartDate] = useState(new Date()); // Default start date is current date
  const [SelectedEndDate, setSelectedEndDate] = useState(getEndOfMonth(new Date())); // Default end date is end of current month

  // Initialize displayEndDate with current month's end date
  const [displayEndDate, setDisplayEndDate] = useState(
    getLastDateOfCurrentMonthPayloadFormat()
  );

  // Function to get the last day of the selected month
  const getLastDayOfMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
  };

  const openDatePicker = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };

  const datePickerOnChange = (date) => {
    const formattedStartDate = date.toLocaleDateString("en-GB", {
      year: "numeric",
      month: "long", // Display only month and year
    });
    const DaformattedStartDate = date.toLocaleDateString("en-GB", {
        year: "numeric",
        month: "long", // Display only month and 
        day: "2-digit", // Display the exact last day of the month
        
      });
      
    const lastDayOfMonth = getLastDayOfMonth(date);
    const formattedEndDate = lastDayOfMonth.toLocaleDateString("en-GB", {
        year: "numeric",
        month: "long", // Display month and year only
        day: "2-digit", // Display the exact last day of the month
      });
  
     Swal.fire({
                text:  DaformattedStartDate+"to"+formattedEndDate,
                icon: "success",
    
                ...swalAlertPopProps,
              });
    setstartDateFormat(formattedStartDate);
    setSelectedStartDate(date);

    // Calculate and set the end date for the selected month
   
   
    // Update displayEndDate and endDate
    setDisplayEndDate(formattedEndDate);
    setEndDate(formattedEndDate);
    setSelectedEndDate(lastDayOfMonth); // Update the selected end date
  };

  useEffect(() => {
    if (startDateFormat && getFirstDateOfCurrentMonthPayloadFormate() !== startDateFormat) {
      const parsedDate = new Date(startDateFormat);
      if (!isNaN(parsedDate)) {
        datePickerOnChange(parsedDate);
      }
    }
  }, [startDateFormat]);

  return (
    <>
      <TextField
        fullWidth
        readOnly
        onClick={openDatePicker}
        id="date"
        sx={{
          mt: 2,
          "& .MuiInputBase-root": { height: "45px" }
        }}
        value={SelectedStartDate.toLocaleDateString("en-GB", { year: "numeric", month: "long" }) }
        label={
          <Box
            sx={{
              flex: 4,
              color: "grey",
              cursor: "pointer",
              whiteSpace: "nowrap",
            }}
          >
            Date :
          </Box>
        }
        InputProps={{
          endAdornment: (
            <EventIcon
              sx={{
                color: (theme) => theme.palette.primary.main,
                cursor: "pointer",
              }}
            />
          ),
        }}
      />

      <DatePicker
        hidden={true}
        selected={SelectedStartDate}
        onChange={datePickerOnChange}
        className="custom-datepicker"
        ref={datePickerRef}
        showMonthYearPicker // This enables month and year selection
        dateFormat="MMMM yyyy" // Format to display month and year only
        onClickOutside={() => {
          datePickerRef.current.setOpen(false);
        }}
      />
    </>
  );
};
